module.exports = {
  "CS_info2_Network_Image_HvHe": "Imagem no site",
  "CS_one_Batch_configuration_Ffmp": "Configuração em lote",
  "CS_5_When_the_PbND": "O usuário informante é um passageiro. Somente ferramentas de passageiro se aplicam.",
  "CS_one_Scenario_ENG_mFbn": "Cenário (pt_br)",
  "CS_info_Comments_failed_mQNX": "Não é possível adicionar comentários",
  "CS_5_Do_not_kYRj": "Você está repetindo demais essa atividade",
  "CS_2_It_is_vdcu": "Primeiro responda via mensagem no aplicativo (também será enviada uma notificação por e-mail). Se não souber como fazer isso, peça ajuda ao seu supervisor.",
  "CS_1_Template_oNtV": "Modelo",
  "CS_tickets_User_Type_Wdya": "Tipo de usuário",
  "CS_info2_Please_fill_uLvw": "Insira…",
  "CS_one_Operation_Log_hsdo": "Registro de ações",
  "CS_one_Tips_vbZx": "Atenção",
  "CS_one_Upload_successfully_DliZ": "Arquivo carregado corretamente. Ele entrará em vigor no país aplicável depois de ser criado. Informe os colegas relevantes no país correspondente.",
  "CS_info2_Cancel_link_vxaa": "Remover link",
  "CS_1_Action_pnrH": "Ações",
  "CS_pop_The_conversation_dKAF": "Horário de início da chamada",
  "CS_one_Upload_files_TzsC": "Enviar arquivo",
  "CS_1_Operational_results_nOpZ": "Resultado da ação",
  "CS_one_Please_check_SuZo": "2. Carregue o modelo preenchido (confira se tudo foi inserido corretamente antes de carregar).",
  "CS_1_Temporary_CTPp": "Salvar temporariamente",
  "CS_1_Solved_ooGh": "Resolvido",
  "CS_page_Unable_to_aXip": "Não foi possível criar o ticket",
  "CS_one_Enter_rfGy": "Insira",
  "CS_1_Message_Title_AJzH": "Assunto do e-mail",
  "CS_2_Worksheet_ID_SxiT": "O ID do ticket é gerado ao criá-lo",
  "CS_2_Copy_the_hSGF": "Número de telefone copiado. Essa ação foi registrada. Lembre-se de seguir as políticas de segurança da informação da empresa.",
  "CS_one_Classification_of_qEgR": "Gestão de Motivo do contato (MC)",
  "ark.global.cs.field.values.ticket_tab_im": "Chat ao vivo",
  "CS_qa_This_behavior_dZrQ": "As operações nesta página são registradas. Siga as políticas de Segurança da Informação da empresa.",
  "CS_Page_Driver_List_Uxwj": "Lista de motoristas",
  "CS_1_Thank_you_WUlL": "Agradecemos seus comentários!",
  "CS_info_Select_Question_QkZC": "Selecione um Motivo do contato",
  "CS_5_Your_query_uvJB": "Limite máximo de consultas atingido",
  "CS_one_Determination_GUbi": "Confirmar",
  "CS_buchong_eFit_JNbR": "Não é possível encontrar as informações do pedido, pois o número de telefone é inválido ou o usuário não está registrado.",
  "CS_Page_Rider_Details_Ovwp": "Detalhes do passageiro: ID do passageiro",
  "CS_1_Amount_mYAW": "Valor",
  "CS_Page_Order_Details_oAUq": "Detalhes da corrida: ID da corrida",
  "CS_Adjustment_YdjN_bXSL": "O motivo para pular o SOP é inadequado. Tente outro.",
  "CS_Adjustment_gjOY_YpxQ": "As informações do SOP são inconsistentes com as do PC",
  "Fleet_0303_Fleet_WorkRegime_Contents_TAuX": "Sem informações por enquanto",
  "CS_buchong__yLly": "Não foi possível usar as ferramentas, pois o número de telefone é inválido ou o usuário não está registrado",
  "CS_Tools_1209_Optimus_Coupon_Inuquiry_Scope_of_bBLW": "ID do passageiro ",
  "CS_one_Batch_effective_prPl": "Validação em lote",
  "CS_one_Country_and_Qyqv": "Configuração de país e linha de negócio",
  "CS_page_Please_fill_ikWU": "Selecione um grupo do ticket",
  "CS_tickets_Three_days_pcmE": "Últimos 3 dias",
  "CS_one_New_Batch_wEKW": "Criação em lote",
  "CS_one_Abandoned_ROgG": "Descartado",
  "CS_1_Enter_content_haAO": "Insira o texto aqui",
  "CS_one_Description_ENG_vIZz": "Descrição (pt_br)",
  "CS_page_Work_orders_MRDt": "Ticket encerrado com sucesso",
  "CS_one_Translation_configuration_lnQZ": "Configuração de tradução",
  "CS_tickets_Compensation_deduction_GJfV": "Método de compensação/dedução",
  "CS_info_Like_failure_mPup": "Ocorreu um erro. Tente novamente.",
  "CS_info2_Make_sure_zyfT": "Antes de selecionar esta opção, certifique-se de que as informações da cidade estejam indisponíveis para este ticket",
  "Help_version_Business_lines_VOJX": "Categoria",
  "CS_4_Topographic_tools_KqUl": "Mapa",
  "CS_Page_Driver_Type_UnIR": "Tipo de motorista",
  "CS_information_Order_Basis_WKGU": "Informações básicas da corrida",
  "Magellan_improvement_The_company_CoIp": "Informações como mensagens instantâneas e histórico de chamadas são dados confidenciais que pertencem à empresa. Use-as de maneira sensata de acordo com nossos regulamentos de segurança da informação. Cada consulta será registrada pelo sistema. É estritamente proibido tirar fotos, baixar ou divulgar esses dados para terceiros fora da empresa.",
  "CS_Page_Passenger_Details_vgGv": "Página de detalhes do passageiro",
  "CS_pop_No_xtIB": "Não",
  "CS_pop_Cancel_byla": "Voltar",
  "Magellan_improvement_IM_Information_weuP": "Informações sobre mensagem instantânea",
  "CS_info2_Reset_Fiiu": "Redefinir",
  "CS_1_E_mail_rKAg": "E-mail",
  "CS_tickets_Administrator_BcHW": "Gerente",
  "CS_one_Action_Type_uHTo": "Tipo de ação",
  "Magellan_improvement_Question_description_GyVD": "Descrição do problema",
  "CS_page_Do_you_UfOG": "Transferir ticket para {{ticketgroup}}?",
  "CS_page_Transportation_orders_UWhR": "Transferir ticket",
  "CS_tickets_One_month_IrdR": "Último mês",
  "CS_5_Unchecked_user_vuUZ": "Informações de registro do usuário não encontradas",
  "CS_Settings_Countless_lEdc": "Não há dados",
  "CS_page_Transferring_the_ZnkX": "Ticket transferido",
  "Magellan_improvement_Call_completed_hbKz": "Chamada concluída",
  "CS_improvement_Passenger_JnXD": "Passageiro",
  "CS_Page_Driver_Basic_SItd": "Informações básicas do motorista",
  "CS_one_Description_NrBC": "Descrição",
  "CS_Adjustment_abEf_PYol": "O SOP contém um bug",
  "CS_4_Tools_can_ZQSK": "As ferramentas só podem ser usadas na página de processamento de tickets do sistema de Atendimento ao Cliente",
  "CS_one_Owner_EwUa": "Proprietário",
  "CS_Page_Model_List_WVIO": "Lista da classe do carro",
  "CS_Page_Common_tools_FTJG": "Ferramentas comuns",
  "CS_info_Click_here_MKRf": "Clique aqui para associar um pedido",
  "CS_thpoptimization__sSiH": "Frota",
  "CS_3_Optional_kdMP": "opcional",
  "CS_pop_User_Phone_hTGd": "Número de telefone do usuário",
  "CS_Page_City_name_atjF": "Nome da cidade",
  "CS_improvement_Call_SmCo": "Horário da chamada",
  "Help_version_Enter_number_MyWJ": "Número de telefone recebido",
  "CS_1_Comments_RcMN": "Enviar",
  "CS_info_This_page_Cpww": "Par evitar atrasos no sistema, só é possível abrir até dez guias de tickets nesta página. Por favor, feche as guias que não estão em uso.",
  "CS_tickets_Work_order_NQJE": "Status do ticket",
  "CS_one_Entered_into_mEwl": "Em vigor",
  "CS_Adjustment_txhj_lfbO": "Preencha o SOP antes de prosseguir",
  "CS_tickets_Three_months_Jdzc": "Últimos 3 meses",
  "CS_1_Order_ID_bsCY": "ID da solicitação",
  "CS_tool_Work_order_LjeC": "Status do ticket",
  "CS_Page_Trip_Compl_Vcnk": "Horário de término da corrida",
  "CS_page_No_permissions_mYZG": "Você não tem permissão para transferir este ticket",
  "CS_1_Send_email_DDPi": "Confirmar envio de e-mail",
  "CS_buchong__BYdr": "Não foi possível localizar as informações do usuário ou usar o recurso de verificação de permissões dinâmicas porque o número de telefone é inválido ou o usuário não está registrado.",
  "CS_one_New_Problem_ORNp": "Criar novo Motivo do contato (MC)",
  "CS_Page_Select_the_kqHS": "Selecione as condições de filtragem",
  "Help_version_Country_XKEj": "País",
  "CS_translation_Selection_of_yatg": "Selecionar o motivo da compensação",
  "CS_2_Please_select_Zapc": "Selecione",
  "CS_2_Refund_amount_ikWV": "Valor do reembolso",
  "CS_Page_Enter_Order_TeQM": "Insira a ID da corrida",
  "CS_Page_Type_SnKr": "Modelo",
  "CS_QA1_More_than_uScx": "Se houver mais de {{amount}} entradas, somente {{amount}} serão exibidas.",
  "CS_one_Operation_Records_bTgJ": "Registro de ações",
  "CS_1_ID_VNVI": "ID do ticket",
  "CS_pop_Bind_session_qEwk": "Adicionar uma chamada",
  "CS_info2_Jump_link_pUcH": "Link de redirecionamento",
  "CS_tickets_The_user_iVJx": "Este usuário é um gerente de frota (clique para ver os detalhes)",
  "ark.global.cs.field.values.ticket_tab_compensation": "Registro do processamento",
  "CS_info2_Depositary_UmEY": "Responsável",
  "CS_initialization_Create_a_xRhB": "Crie um ticket primeiro",
  "CS_pop_Bind_lDQM": "Adicionar",
  "CS_Page_Order_List_IiWy": "Lista de corridas",
  "CS_one_Status_QWZW": "Status",
  "CS_information_Single_phone_vKdi": "Nº de telefone do solicitante",
  "CS_2_Driver_balance_otCh": "Dedução do saldo do motorista",
  "CS_Notice_Please_submit_iVZB": "Insira seus comentários para este cartão de processo antes de enviar",
  "CS_info2_Link_kBeS": "Associação",
  "CS_1_You_do_Czvx": "Você não tem permissão para ver informações privadas do cliente. Realize a verificação do sistema ou entre em contato com o administrador.",
  "CS_info_Process_cards_ccmd": "Cartão de processo",
  "CS_improvement_The_main_DIgv": "O chamador desligou",
  "Help_2_More_OZUg": "Mais",
  "CS_1_Recipients_jNBa": "Para",
  "CS_buchong1__XPiG": "Não foi possível executar essa ação, pois a autenticação dinâmica falhou. Complete a autenticação dinâmica ou entre em contato com o administrador.",
  "CS_Page_Enter_email_VDKC": "Insira o e-mail",
  "CS_one_Return_axWQ": "Voltar",
  "CS_tickets_Complaint_Manner_UWAQ": "Ticket relacionado a respondente",
  "CS_2_Refundable_mKnQ": "Reembolso disponível?",
  "CS_pop_Whether_to_tvgd": "Criar um ticket sem uma chamada associada?",
  "CS_1_Send_an_oyHo": "Tem certeza de que deseja enviar um e-mail para este usuário?",
  "CS_one_Upload_failed_tubs": "Não foi possível carregar. Tente novamente.",
  "CS_tickets_Order_Work_UDue": "Ticket relacionado a solicitações",
  "Magellan_improvement_ID_HTMT": "ID do ticket",
  "CS_Page_Type_of_Chyl": "Tipo de consulta",
  "CS_initialization_Select_user_QGGG": "Selecione um tipo de usuário",
  "Help_version_Answer_DVQw": "Responder",
  "CS_improvement_Dial_man_vuMm": "Chamador",
  "CS_one_Are_you_QXby": "Tem certeza de que deseja modificar este Motivo de contato (MC)? Uma vez modificado, o Motivo do contato (MC) entrará em vigor no país aplicável. Informe os colegas relevantes no país correspondente.",
  "CS_info2_Data_Not_mVCx": "Sem resultados por enquanto",
  "CS_information_Purpose_tIXL": "Destino",
  "CS_Page_Response_mode_tfSQ": "Modo de resposta",
  "CS_Page_Order_Status_ZJEQ": "Status da solicitação",
  "CS_1_Internal_message_Dmzz": "Mensagem interna",
  "CS_1_More_online_ugOQ": "Ver mais histórico do chat",
  "CS_one_1_Please_EOBr": "1. Baixe e preencha o modelo a seguir.",
  "CS_one_Applicable_States_HNdh": "País aplicável",
  "CS_translation_Submission_akuK": "Enviar",
  "CS_one_Basic_information_akKk": "Informações básicas",
  "CS_Page_Driver_Mobile_mQCL": "Número de telefone do motorista",
  "CS_one_Father_classification_ZASx": "Nível 1 da categoria principal (pt_br)",
  "CS_info_Select_user_WEYA": "Selecione o Tipo de usuário e a Categoria para obter os Motivos de contato disponíveis",
  "CS_information_Order_Status_ZZvi": "Status da corrida",
  "CS_Page_Please_choose_SkUr": "Selecione...",
  "CS_one_Import_data_zhsI": "Importar dados",
  "CS_one_Applicable_Business_ERQA": "Categoria aplicável",
  "CS_1_Off_aqDQ": "Fechar",
  "CS_info2__unk_MkzP": "Enviar imagem",
  "CS_qa_Successfully_saved_GaYt": "Ticket salvo com sucesso",
  "CS_info2_User_Type_ylaU": "Tipo de usuário",
  "CS_1_Send_asynchronous_rowd": "Enviar mensagem no aplicativo e no e-mail",
  "CS_1_Cancel_UVIs": "Cancelar",
  "CS_info2_link_Text_Gvnh": "Informação associada",
  "CS_Page_Enter_Passenger_vcdv": "Informe a ID do passageiro",
  "CS_one_Cancel_sSYi": "Voltar",
  "CS_one_Add_VToU": "Adicionar",
  "CS_one_Download_Template_XYvP": "Baixar modelo",
  "CS_tickets_Compensation_Deducperiod_HFiB": "Tempo de execução da compensação/dedução",
  "CS_info2_Picture_text_mnMQ": "Descrição da imagem",
  "CS_1_User_Mobile_aNYY": "Nº de telefone do usuário",
  "CS_Page_Product_line_gPCE": "Categoria",
  "CS_info_There_is_vxeJ": "Não há conteúdo disponível para este Motivo do contato. Para obter mais informações, confira a Base de conhecimento.",
  "CS_tickets_Today_klqB": "Hoje",
  "CS_tickets_Search_dVXa": "Pesquisar",
  "CS_improvement_Driver_ZOiL": "Motorista",
  "CS_one_Scenarios_qeVe": "Cenário",
  "CS_reconstruction_Determination_MvvP": "Confirmar",
  "CS_2_Time_of_ynEo": "Horário do reembolso",
  "CS_1_operator_gItF": "Ação realizada por",
  "CS_info2_Image_address_QJoY": "URL da imagem",
  "CS_tickets_Type_of_DvxN": "Tipo de ticket",
  "CS_tickets_Half_a_SjoS": "Últimos 6 meses",
  "CS_info_Into_the_OLWz": "Info de entrada do usuário",
  "CS_page_Unable_to_sJgg": "Não foi possível resolver o ticket",
  "CS_1_Passengers_rXbp": "Passageiro",
  "CS_page_Unable_to_lQkV": "Não foi possível encerrar o ticket",
  "CS_1_Compensation_Deduction_eyNT": "Detalhes de compensação/dedução",
  "CS_page_Unable_to_lWwm": "Não foi possível salvar o ticket temporariamente",
  "CS_Page_Passenger_ID_WiFY": "ID do passageiro",
  "CS_Page_Clear_Query_qLSf": "Limpar critérios de pesquisa",
  "CS_info2_View_link_fyZT": "Ver link",
  "CS_tickets_Work_order_STXN": "Histórico de tickets",
  "CS_2_Copy_successfully_rlpe": "Copiado com êxito",
  "CS_one_Grade_classification_sVNq": "Categoria principal",
  "CS_Page_Driver_Details_Mnzk": "Página de detalhes do motorista",
  "CS_page_Successful_temporary_sFHU": "Ticket salvo temporariamente",
  "CS_page_Successfully_created_ffvZ": "Ticket criado com sucesso",
  "CS_Page_Purpose_rNGk": "Local de desembarque",
  "CS_Tools_1231_Optimus_AdyenTool_Failure_TWRQ": "Erro",
  "CS_thpoptimization_Copy_the_CPlW": "Endereço de e-mail copiado. Essa ação foi registrada. Lembre-se de seguir as políticas de segurança da informação da empresa.",
  "CS_1_Status_of_Dkxj": "Status",
  "CS_Adjustment_VsHy_RwJo": "Informe um motivo para ignorar",
  "CS_reconstruction_Select_Business_DYpG": "Selecione uma categoria",
  "CS_Settings_Can_not_wuTx": "Não pode ficar em branco",
  "CS_1_Action_Name_sFel": "Ação",
  "CS_Page_Driver_Details_uNcn": "Detalhes do motorista: ID do motorista",
  "CS_pop_Action_zZIq": "Ações",
  "CS_pop_Confirmation_lTpQ": "OK",
  "CS_improvement_Phone_records_Kgdt": "Histórico de chamadas",
  "Help_buchong_Reply_RcHf": "Responder",
  "CS_one_Classification_of_YYEd": "O Motivo de contato (MC) está relacionado à segurança?",
  "CS_info2_Association_ZCdq": "Associar",
  "CS_1_Work_orders_fADf": "Mensagem interna enviada com sucesso para o ticket",
  "CS_qa_Collapse_DJRI": "Mostrar menos",
  "CS_improvement_Voice_duration_TNdW": "Duração da chamada",
  "CS_1_Work_order_pUHt": "E-mail enviado com sucesso para o ticket",
  "CS_1_Mail_address_Hxvv": "Endereço de e-mail",
  "CS_Page_Driver_ID_HNzY": "ID do motorista",
  "CS_info_Select_a_CKYG": "Selecione uma cidade. Se nenhuma cidade estiver disponível, você pode selecionar N/A.",
  "Magellan_improvement_When_you_WyDX": "Os pedidos serão cancelados assim que forem fechados. Escolha atentamente.",
  "CS_tickets_Compensation_ID_PjEu": "ID de compensação",
  "CS_5_When_the_WPIZ": "O usuário informante é um motorista. Somente ferramentas de motorista se aplicam.",
  "CS_one_Please_confirm_BmHM": "Confirme os Motivos do contato (MC) selecionados e clique em “Confirmar” para validá-los.",
  "CS_1_Send_email_oriC": "Enviar e-mail",
  "CS_tickets_One_week_YsBK": "Última semana",
  "CS_page_Whether_the_pGhP": "Tem certeza de que este ticket foi resolvido? Depois de confirmar, o status do ticket será alterado para [Processando].",
  "CS_one_Off_Zqiv": "Fechar",
  "CS_2_For_security_YqmP": "Por motivos de segurança, o endereço de e-mail do destinatário está oculto. Isso não afetará a comunicação.",
  "CS_info_Please_fill_yjjm": "Insira o número de telefone",
  "CS_info2_Business_Type_KDsP": "Categoria",
  "CS_1_Send_internal_kufI": "Enviar mensagem",
  "CS_1_Save_dSGz": "Salvar",
  "CS_page_Priority_processor_Gwtc": "Responsável preferencial",
  "CS_1_The_author_xIBI": "De",
  "CS_one_Details_Page_mdDC": "Página de detalhes do Motivo do contato (MC)",
  "CS_page_If_you_RZwt": "Tem certeza de que deseja salvar temporariamente este ticket? Isso mudará o status do ticket para [Salvo temporariamente].",
  "CS_page_Work_order_vikw": "Ticket resolvido",
  "CS_1_Type_kuvZ": "Tipo",
  "CS_1_Role_QhMU": "Função",
  "CS_one_Please_confirm_ViBj": "Confirme os Motivos do contato (MC) selecionados e clique em “Confirmar” para descartá-los.",
  "CS_2_Refund_history_NZXS": "Histórico de reembolso",
  "CS_info2_Related_Worksheets_TnzD": "Associar ticket (opcional)",
  "CS_Page_City_XSgD": "Cidade",
  "CS_qa_Customer_Service_CeXF": "Representante da Central de Ajuda (RCA)",
  "CS_Page_Passenger_List_ajVZ": "Lista de passageiros",
  "CS_1_Latest_before_UTUl": "Ordenar por mais recente",
  "CS_5_Copy_successfully_CcCu": "Copiado",
  "CS_1_During_Operation_xWpb": "Hora da ação",
  "CS_one_Please_select_IHKO": "Selecione um país e uma linha de negócio",
  "CS_one_During_Operation_JDju": "Hora da ação",
  "CS_qa_More_Paqa": "Mais",
  "CS_info_Select_Channel_HWlg": "Selecione um canal",
  "CS_info2_Rider_Issuing_TDAx": "Horário da solicitação de corrida do passageiro",
  "CS_4_Contact_Records_NcjV": "Histórico de contatos",
  "ark.global.cs.TOOL_ACTION_associated_ticket": "Associou um ticket",
  "Magellan_improvement_Information_Secure_LRtP": "Lembrete de confidencialidade de informações",
  "CS_Page_Enter_driver_CirL": "Insira a ID do motorista",
  "CS_Page_Select_driver_rrhQ": "Selecione um tipo de condutor",
  "CS_qa_There_is_vPke": "Há conteúdo não enviado em {{inputbox}}. Sair desta página deletará o conteúdo. Tem certeza que deseja sair?",
  "CS_one_Father_classification_lZII": "Nível 2 da categoria principal (pt_br)",
  "CS_info_Mobile_phone_SGyc": "Não é possível encontrar as informações do usuário, pois o número de telefone é inválido ou o usuário não está registrado.",
  "CS_one_Export_data_YQDj": "Exportar dados",
  "CS_information_Departure_zaxW": "Local de partida",
  "CS_TicketHandlingPage_This_CR_VWpW": "O SOP manual já é compatível com este MC. Processe o ticket de acordo com o SOP.",
  "CS_2_Work_Order_anVq": "Grupo do ticket",
  "CS_info_Select_Business_bhhu": "Selecione uma categoria",
  "CS_Adjustment_ZMnG_gsAL": "Outro",
  "CS_information_Order_ID_vVme": "ID da corrida",
  "CS_one_User_Type_iRnJ": "Tipo de usuário",
  "CS_4_Order_details_ulUl": "Detalhes da corrida",
  "CS_one_Edit_LtHm": "Editar",
  "CS_info2_If_there_BivS": "Selecione um ticket associado (se houver)",
  "CS_Page_Billing_models_otMq": "Tipo de veículo",
  "CS_Page_Enter_your_kKAs": "Insira o número de telefone",
  "CS_page_No_email_Uhdl": "Você não tem permissão para enviar um e-mail de resposta",
  "CS_Adjustment_VZmt_VnjZ": "Escolha um motivo para ignorar",
  "CS_Adjustment_oVPm_qPQP": "O usuário está offline ou saiu do chat",
  "CS_one_View_miAp": "Ver",
  "CS_fits_OUZR_woGE": "Linha de produto do pedido",
  "CS_1_Compensation_deduction_pTJS": "Canal de compensação/dedução",
  "CS_info2_More_akQx": "Ver mais",
  "CS_1_Work_orders_cLNO": "Mensagem no aplicativo enviada com sucesso para o ticket",
  "CS_1_Roaming_wzIe": "Roaming",
  "CS_5_Copy_qVgF": "Copiar",
  "CS_Page_Star_Standard_ICmt": "Avaliação",
  "CS_compensation_Refusal_of_hveW": "Compensação recusada",
  "CS_initialization_Select_Order_dqhz": "Selecione uma solicitação",
  "CS_TicketHandlingPage_Artificial_SOP_vwXh": "SOP manual",
  "CS_Page_Passenger_Email_qveC": "E-mail do passageiro",
  "CS_Page_Between_the_eqMJ": "Horário de criação",
  "CS_Page_Business_Type_nsHy": "Categoria",
  "CS_page_Do_you_tMFN": "Quer encerrar este ticket?",
  "CS_2_Work_Order_fABY": "ID do ticket copiado com êxito",
  "CS_Page_Pick_up_CNzD": "Local de embarque",
  "More": "Mais",
  "CS_improvement_Unanswered_qcLt": "Sem resposta",
  "CS_1_Related_Orders_hkRo": "Associar pedido",
  "CS_info_Comments_successfully_YcZj": "Comentário adicionado",
  "CS_tickets_Enter_the_FCWt": "Ticket relacionado a usuário informante",
  "CS_information_Booking_session_CBQY": "Horário agendado",
  "ark.global.cs.field.values.ticket_tab_inner_reply": "Mensagem interna",
  "CS_Page_Driver_ID_TPqW": "Número da ID",
  "CS_info_Select_Work_KXNc": "Selecione um grupo do ticket",
  "Help_conversations_Robot_chat_QzDc": "Histórico da conversa no chatbot",
  "CS_tickets_Between_the_mEqx": "Horário de criação",
  "CS_2_Passenger_Basic_FFNN": "Informações básicas do passageiro",
  "CS_page_Do_you_GgIB": "Transferir ticket para {{handler}} em {{ticketgroup}}?",
  "CS_1_Enter_text_NYGo": "Escreva seu comentário aqui",
  "CS_1_Compensation_ID_BGFF": "ID de compensação",
  "CS_1_Work_order_wyuA": "Informações do ticket",
  "CS_info_Select_User_rSZo": "Selecione um tipo de usuário",
  "CS_one_Classification_of_QAlG": "Motivo do contato",
  "ark.global.cs.field.values.ticket_tab_asyc_msg": "Mensagem no aplicativo",
  "CS_pop_Can_t_QjXi": "Não encontrou a chamada associada?",
  "Help_version_Telephone_entry_PGun": "Barra do telefone",
  "CS_one_You_can_MflO": "Caracteres especiais não são permitidos, exceto “()”, “?” e espaços",
  "ark.global.cs.field.values.ticket_tab_outer_reply": "Resposta externa",
  "CS_one_operator_Itcg": "Operador",
  "CS_one_Organization_eUqC": "Empresa",
  "CS_5_Comply_with_YDuq": "Por favor, siga as políticas de Segurança da Informação da empresa.",
  "CS_prompt_Driver_registration_mBqS": "Tarefa de análise do cadastro do motorista não encontrada",
  "CS_Page_Order_ID_tWzK": "ID da solicitação",
  "CS_one_Classification_of_jyqM": "Motivo do contato (MC) (pt_br)",
  "CS_Page_Status_of_SBuB": "Status do pagamento",
  "CS_Page_Enter_ID_IgwX": "Número da ID",
  "TEXT_ERRMSG_OK": "Concluído",
  "Help_want__Change_pUeS": "Mais sugestões",
  "Help_version_Thread_tmgY": "Motivo do contato",
  "CS_Page_Passenger_Mobile_ckjq": "Número de telefone do passageiro",
  "CS_qa_User_Tjti": "Usuário",
  "CS_one_Classification_of_AlnN": "Motivo do contato (MC) (pt_br)",
  "CS_1_Help_us_ilXL": "Dê sua opinião sobre este processo",
  "CS_one_Are_you_eqhN": "Tem certeza de que deseja criar um novo Motivo de contato (MC)? Uma vez criado, o novo Motivo do contato (MC) entrará em vigor no país aplicável. Informe os colegas relevantes no país correspondente.",
  "CS_initialization_Select_City_uKvx": "Selecione uma cidade",
  "CS_pop_Bind_fsRd": "Adicionada",
  "CS_2_Classification_of_QmXS": "Motivo do contato",
  "kfcommon-fe-i18n-knowledge---knowledgeConfig.robot": "Robô",
  "ark.global.cs.field.title.ticket_tab_log": "Registro do ticket",
  "CS_pop_Yes_yDMc": "Sim",
  "CS_tickets_One_year_gmPi": "Último ano",
  "CS_page_Internal_reply_pruf": "A resposta interna não pode ficar em branco",
  "ark.global.cs.field.title.ticket_tab_info": "Registro de informações",
  "CS_Page_Front_ID_apqL": "Detalhes da frota: ID da frota",
  "CS_1_User_Name_dhWx": "Nome do usuário",
  "CS_one_Batch_scrap_qzlO": "Descarte em lote",
  "CS_info2__unk_RIxc": "Inserir",
  "CS_Tools_colombo_tool_platform_Cancel_gNzm": "Cancelar",
  "CS_one_Parental_classification_zEhp": "Categoria principal (pt_br)",
  "Help_buchong_Reply_Record_dsUU": "Histórico de respostas",
  "CS_info2_All_orders_yVmI": "Mostrando todos os pedidos deste usuário nos últimos 180 dias",
  "CS_1_The_oldest_vXHS": "Ordenar por mais antigo",
  "CS_monitor_Each_compensation_BfxO": "Todas as solicitações de compensação são registradas. Verifique se as solicitações obedecem à política de compensação do Atendimento ao Cliente. Solicitações que não obedecem às diretrizes da política serão analisadas internamente.",
  "comTool.channelRefundERR": "Esta corrida não possui um método de pagamento que seja reembolsável",
  "review.auditInfo": "Detalhes",
  "list.orderId": "Identificação da solicitação",
  "comTool.refundStatus": "Status do reembolso",
  "common.pleaseSelect": "Selecione",
  "new.tags": "tags",
  "comfort.vehicleModel": "Modelo do veículo",
  "comfort.requiredYear": "Ano >",
  "chat.save": "Salvar",
  "review.submitReview": "Enviar para análise",
  "new.continueHandle": "Continue a tratar",
  "comTool.driverV": "Não é possível compensar porque o tipo de usuário é passageiro",
  "comTool.balance": "Saldo",
  "automation.action": "Ação",
  "list.compensatePhone": "Telefone do usuário",
  "staticConfig.false": "Não",
  "work.businessTypeName": "Categoria",
  "new.orderInfo": "Informações da Corrida",
  "review.viewFlowchart": "Visualizar fluxograma",
  "comTool.riderCompensation": "Compensação do passageiro",
  "comTool.driverActualRevenue": "Valor real que o motorista recebe",
  "comTool.driverId": "ID do motorista",
  "new.knowdgeBase": "Base de conhecimento",
  "comTool.passenger": "Passageiro",
  "list.channel": "Canal",
  "clipper.clipperTitle": "Informações do Ticket de Safety relacionado",
  "comTool.reasonForCompensation": "Motivo da compensação",
  "comTool.driverPhone": "Número de telefone do motorista",
  "review.commitTime": "Horário de envio",
  "common.system": "Sistema",
  "common.more": "abrir",
  "comTool.amountERR": "Erro no valor",
  "staticConfig.yes": "Sim",
  "staticConfig.operationSuccessfully": "Operação bem sucedida",
  "list.worksheetId": "ID do Ticket",
  "comTool.status": "Status",
  "comTool.driverDeduction": "Dedução do motorista",
  "new.ticketRefreshV": "Este ticket foi atualizado, continue ou não",
  "common.jingmoThreeMonths": " Only Display Silence Log of Latest Three Month",
  "comTool.refundCost": "Qtd reembolsada",
  "list.amount": "Valor",
  "review.auditor": "Analisado por",
  "common.Toolbox": "Caixa de ferramentas",
  "common.ticketList": "Busca de Tickets",
  "comfort.city": "Cidade",
  "review.taskName": "Tipo de tarefa",
  "staticConfig.channelSetting": "configurações do canal",
  "comTool.detailsOfCompensation": "Detalhes da compensação",
  "clipper.clipperDetail": "Esse ticket já possui um ticket de Safety relacionado",
  "comTool.driverCompensation": "Compensação do motorista",
  "review.submitReviewConfirm": "Tem certeza de que deseja enviar estas informações para análise?",
  "new.uploadFailed": "Erro, tente novamente",
  "comTool.operationStatus": "Status",
  "clipper.status": " Status do ticket",
  "review.actions": "Ações",
  "comTool.passengerCouponV": "Cupom de compensação não pode ser solicitado, pois o tipo de usuário é motorista",
  "work.Workbench": "Minha área de trabalho",
  "comTool.cost": "Valor",
  "chat.transfer": "Transferir",
  "chat.onlineResponse": "Mensagem no aplicativo",
  "review.auditTime": "Analisado em",
  "staticConfig.no": "Não",
  "staticConfig.businessTypeName": "The name of Business Type",
  "new.NullEmergencyContact": "O usuário não definiu o contato de confiança",
  "new.emergencyContact": "Contato de confiança",
  "common.confirm": "Confirmar",
  "comfort.model": "Modelo do veículo",
  "clipper.T3first": "Horário ticket foi reivindicado por T3",
  "common.abnormalReminder": "Alerta de risco",
  "new.editTime": "edit time",
  "comTool.pay": "Compensação da carteira do passageiro",
  "review.undoChanges": "Desfazer alterações",
  "comTool.channelName": "Nome do canal",
  "callInfo.operation": "Operação",
  "clipper.creationDate": " Horário de criação do ticket",
  "common.continueTocompensate": "Compensar",
  "comTool.coupon": "cupom",
  "list.amountRange": "Escopo do valor",
  "comTool.channelRefund": "Reembolso no canal original",
  "clipper.ticketID": " Clipper Ticket ID",
  "comfort.search": "Buscar",
  "clipper.T2first": " Horário ticket foi reivindicado por T2",
  "new.PleaseCreateTicket": "Crie um ticket primeiro",
  "comTool.refund": "Reembolso",
  "detail.handle": "tratar",
  "new.fileBig": "Selecione um arquivo inferior a 5MB",
  "create.NewTicket": "Novo ticket",
  "staticConfig.true": "Sim",
  "review.auditResult": "Resultado",
  "new.editUser": "editor",
  "review.modify": "Editar",
  "detail.handleV": "This ticket is under processing. Are you sure to claim it?",
  "new.refreshTicket": "Atualize a página",
  "comTool.routeOfCompensation": "Forma de compensação",
  "common.recommendationNotcompensate": "Recomendação: não compensar.",
  "common.to": "mudar para",
  "comTool.noOrderAll": "Este bilhete não tem ordem, portanto a compensação não pode ser suportada",
  "clipper.clickToView": "Clique para acessar",
  "common.up": "Ocultar",
  "verify---id_no_co": "Verify",
  "CS_Service_The_driver's_JbyZ": "Driver’s level was {{driver_level}} when this ticket was created",
  "CS_Service_Driver_Level_qpqY": "Driver Level",
  "CS_page_Site_Name_dYcm": "Stop Name",
  "CS_page__unk_uZmz": "Minibus Info",
  "CS_page_Cancelled_xyYr": "Cancelled",
  "CS_notification_dwyv_UnUJ": "This inbound user is a fleet partner. Only Fleet tools are applicable.",
  "CS_page_Actual_arrival_YPiM": "Actual Arrival Time",
  "CS_page_This_order_jAmf": "Trip Stops",
  "CS_page_Estimated_arrival_QwhV": "Estimated Arrival Time"
}